import { useEffect, useState } from "react";
import { LocaleConfig, SUPPORTED_LOCALES } from "./i18n.config";
import { fetchSupportedLocales } from "./localesService";

/**
 * Fetches the list of supported locales from the Avalara data platform
 * (`{dataService}/api/v1/locales`) and returns them as `LocaleConfig[]`
 * for use in the Skylab locale switcher.
 *
 * Falls back to the static `SUPPORTED_LOCALES` list from `i18n.config.ts`
 * if the API call fails, ensuring the switcher always has options to show.
 *
 * @returns Array of `LocaleConfig` objects — empty until the API responds.
 */
export const useLocaleOptions = (): LocaleConfig[] => {
    const [localeOptions, setLocaleOptions] = useState<LocaleConfig[]>([]);

    useEffect(() => {
        fetchSupportedLocales()
            .then(locales => {
                setLocaleOptions(locales.length > 0 ? locales : SUPPORTED_LOCALES);
            })
            .catch(() => {
                setLocaleOptions(SUPPORTED_LOCALES);
            });
    }, []);

    return localeOptions;
};
